import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { InAndOut, InAndOutService } from '../../services/in-and-out.service';

@Component({
  selector: 'app-create-in-and-out',
  templateUrl: './create-in-and-out.component.html',
  styleUrls: ['./create-in-and-out.component.css']
})
export class CreateInAndOutComponent implements OnInit {

  inAndOutForm: FormGroup;

  tipos=[
    {name:'Elija un tipo...',value:''},
    {name:'Entrada',value:'in'},
    {name:'Salida',value:'out'}
  ];

  constructor(
    private inAndOutService: InAndOutService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.createForm();

  }

  createForm() {
    this.inAndOutForm = this.fb.group({
      type: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.inAndOutService.addInAndOut(value);
  }

}
